export default __webpack_public_path__ + "static/media/Harley.163eb6f2.png";